<template>
  <div class="lee-luck-draw">
    <div
      class="lee-luck-draw-layout"
      :style="'width:' + config.width + 'px;height:' + config.height + 'px'"
    >
      <div
        ref="allBg"
        :class="{
          bgcolor: !config.backgroundImage,
          bgimg: config.backgroundImage
        }"
        :style="
          'transform:rotate(' +
            (degBg * 180) / Math.PI +
            'deg);--w:' +
            config.width +
            'px;--h:' +
            config.height +
            'px;--bg:' +
            whichBg
        "
      >
        <img
          v-if="config.backgroundImage"
          :src="config.backgroundImage"
          class="bcimg"
        />
        <div
          class="lee-luck-draw-prizes"
          :style="'transform:rotate(' + (degPrizes * 180) / Math.PI + 'deg)'"
        >
          <canvas
            ref="luckDraw"
            :width="config.width - 2 * config.padding"
            :height="config.height - 2 * config.padding"
          ></canvas>
          <div
            v-if="prizes[0].fonts"
            class="prizes"
            :style="
              'width:' +
                (config.width - 2 * config.padding) +
                'px;height:' +
                (config.height - 2 * config.padding) +
                'px'
            "
          >
            <div class="prizesn">
              <div
                :key="xh"
                v-for="(item, xh) in prizes"
                class="ge"
                :style="
                  'height:' +
                    (config.width - 2 * config.padding) / 2 +
                    'px;transformOrigin:0 ' +
                    (config.width - 2 * config.padding) / 2 +
                    'px;transform:translateX(-50%) rotate(-' +
                    ((xh * perGe * 180) / Math.PI + 22.5) +
                    'deg)'
                "
              >
                <div
                  class="text"
                  :style="
                    'color:' +
                      config.fontColor +
                      ';fontSize:' +
                      config.fontSize +
                      ';bottom:' +
                      item.fonts.top
                  "
                >
                  {{ item.fonts.text }}
                </div>
                <div
                  class="img"
                  :style="'bottom:' + item.imgs.top"
                  v-width
                  :data-scale="item.imgs.width"
                >
                  <img :src="item.imgs.src" :width="item.imgs.width" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="btntextw"
        :style="
          'width:' +
            (config.width - 2 * config.padding) +
            'px;height:' +
            (config.height - 2 * config.padding) +
            'px'
        "
      >
        <div @click="beginDraw" class="btntext">
          <div
            class="btn"
            :style="
              'width:' +
                btnConfig.width +
                'px;height:' +
                btnConfig.width +
                'px;background:' +
                btnConfig.background
            "
          >
            <div
              v-if="!btnConfig.imgs"
              class="arrow"
              :style="
                '--w:' + btnConfig.width / 2 + ';--bc:' + btnConfig.background
              "
            ></div>
          </div>
          <div
            class="img"
            v-for="(item, index) in btnConfig.imgs"
            :key="index"
            :style="'bottom:' + item.top"
            v-width
            :data-scale="item.width"
          >
            <img :src="item.src" :width="item.width" />
          </div>
          <div
            class="text"
            v-for="(item, index) in btnConfig.fonts"
            :key="index"
            :style="
              'color:' +
                item.fontColor +
                ';fontSize:' +
                item.fontSize +
                ';lineHeight:' +
                item.fontSize +
                ';bottom:' +
                item.top
            "
            v-html="item.text"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Zz",
  inheritAttrs: false,
  data() {
    return {
      ctx: null,
      haveClick: false,
      degBg: 0, //这个是盘转动的度数,
      degPrizes: 0, //这个是中间礼物转动的度数,
      num: this.config.rollNum || 6, //这个是转总共多少圈,
      speed: 0, //这个是转速度,
      per: Math.PI / 180, //这个是每次转的度数
      perGe: (2 * Math.PI) / this.prizes.length, //这个是每个格子度数,
      saveDegBg: 0, //这个是保存Bg轉到的度數,
      saveDegPrizes: 0, //这个是保存Prizes轉到的度數,
      pid: 0, //这个是定时器的pandong ID
      position: 0 //这个是转到那个地方,
    };
  },

  mounted() {
    let c = this.$refs.luckDraw;
    this.ctx = c.getContext("2d");
    this.ctx.translate(
      this.config.width / 2 - this.config.padding,
      this.config.height / 2 - this.config.padding
    );
    let ff = this.prizes;
    if (ff[0]) {
      for (let i = 0; i < this.prizes.length; i++) {
        if (this.prizes[i].fonts) {
          this.ctx.beginPath();
          this.ctx.fillStyle = this.prizes[i].background;
          this.ctx.moveTo(0, 0);
          this.ctx.arc(
            0,
            0,
            this.config.width / 2 - this.config.padding,
            -this.perGe * i,
            -this.perGe * (i + 1),
            true
          );
          this.ctx.closePath();
          this.ctx.fill();
        }
      }
    }
  },
  methods: {
    beginDraw() {
      //在按钮上的动作
      if (!this.haveClick) {
        this.$emit("start");
        this.haveClick = true;
      }
    },
    play(inx) {
      this.position = inx;
      this.pid = setInterval(this.move, 1);
    },
    move() {
      if (this.config.rotate) {
        //如果说整个背景要动
        this.bgDong(this.position);
      } else {
        this.prizesDong(this.position);
      }
    },
    bgDong(pos) {
      let addDeg = -this.perGe / 2;
      let lastdeg = this.num * 2 * Math.PI + (pos - 1) * this.perGe - addDeg; //就是说最大的度数为这个，超过他就要停止了
      if (this.degBg >= lastdeg / 2 + this.saveDegBg / 2) {
        this.speed -= 0.01;
        if (this.speed <= 0.04) {
          this.speed = 0.03;
        }
      } else {
        this.speed += 0.01;
      }

      this.speed = Number(this.speed.toFixed(2));
      this.degBg += this.per * this.speed;
      if (this.degBg >= lastdeg) {
        clearInterval(this.pid);
        this.degBg = (pos - 1) * this.perGe - addDeg;
        this.saveDegBg = this.degBg;
        this.speed = 0;
        setTimeout(() => {
          this.$emit("end", this.position - 1);
          this.haveClick = false;
        }, 100);
      }
    },
    prizesDong(pos) {
      let addDeg = -this.perGe / 2;
      let lastdeg = this.num * 2 * Math.PI + (pos - 1) * this.perGe - addDeg; //就是说最大的度数为这个，超过他就要停止了
      if (this.degPrizes >= lastdeg / 2 + this.saveDegPrizes / 2) {
        this.speed -= 0.01;
        if (this.speed <= 0.04) {
          this.speed = 0.03;
        }
      } else {
        this.speed += 0.01;
      }

      this.speed = Number(this.speed.toFixed(2));
      this.degPrizes += this.per * this.speed;
      if (this.degPrizes >= lastdeg) {
        clearInterval(this.pid);
        this.degPrizes = (pos - 1) * this.perGe - addDeg;
        this.saveDegPrizes = this.degPrizes;
        this.speed = 0;
        setTimeout(() => {
          this.$emit("end", this.position - 1);
          this.haveClick = false;
        }, 100);
      }
    }
  },
  computed: {
    whichBg() {
      if (this.config.backgroundImage) {
        return "url(" + this.config.backgroundImage + ")";
      } else {
        return this.config.backgroundColor;
      }
    }
  },
  props: {
    btnConfig: {
      type: Object,
      default() {
        return {
          width: "60",
          background: "#d64737",
          fonts: [
            { text: "开始", fontColor: "#fff", top: "54%", fontSize: "16px" },
            {
              text: "消费10积分",
              fontColor: "#fff",
              top: "45%",
              fontSize: "12px"
            }
          ]
        };
      }
    },
    config: {
      type: Object,
      default() {
        return {
          width: 324,
          height: 324,
          padding: 10,
          fontSize: "14px",
          fontColor: "#d64737",
          backgroundColor: "#d64737",
          rollNum: 12
        };
      }
    },
    prizes: {
      type: Array,
      default() {
        return [
          {
            fonts: { text: "1元红包", top: "80%" },
            imgs: { src: "/luckdraw/zp-0.png", width: "20%", top: "50%" },
            background: "#f9e3bb"
          },
          {
            fonts: { text: "100元红包", top: "80%" },
            imgs: { src: "/luckdraw/zp-1.png", width: "20%", top: "50%" },
            background: "#f8d384"
          },
          {
            fonts: { text: "0.5元红包", top: "80%" },
            imgs: { src: "/luckdraw/zp-2.png", width: "20%", top: "50%" },
            background: "#f9e3bb"
          },
          {
            fonts: { text: "2元红包", top: "80%" },
            imgs: { src: "/luckdraw/zp-3.png", width: "20%", top: "50%" },
            background: "#f8d384"
          },
          {
            fonts: { text: "10元红包", top: "80%" },
            imgs: { src: "/luckdraw/zp-4.png", width: "20%", top: "50%" },
            background: "#f9e3bb"
          },
          {
            fonts: { text: "50元红包", top: "80%" },
            imgs: { src: "/luckdraw/zp-5.png", width: "20%", top: "50%" },
            background: "#f8d384"
          },
          {
            fonts: { text: "0.3元红包", top: "80%" },
            imgs: { src: "/luckdraw/zp-6.png", width: "20%", top: "50%" },
            background: "#f9e3bb"
          },
          {
            fonts: { text: "5元红包", top: "80%" },
            imgs: { src: "/luckdraw/zp-7.png", width: "20%", top: "50%" },
            background: "#f8d384"
          }
        ];
      }
    }
  },
  directives: {
    width: {
      bind: function(el) {
        let bi = el.dataset["scale"].split("%")[0] * 0.01;
        let img = el.childNodes[0];
        img.onload = () => {
          el.style.width = img.width * bi + "px";
          el.style.display = "block";
          el.style.position = "absolute";
        };
      }
    }
  }
};
</script>
<style scoped lang="less">
[v-cloak] {
  display: none;
}
:root {
  --w: auto;
  --h: auto;
}

.prizesn {
  display: flex;
  justify-content: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.prizes {
  position: absolute;
}

.ge {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  left: 50%;
}

.ge .text {
  white-space: nowrap;
  position: absolute;
}

.ge .text,
.ge .img {
  transform: translateY(50%);
}

.ge .img {
  display: none;
}

.btn {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 100%;
  display: flex;
  justify-content: center;
}

.btn .arrow {
  border-style: solid;
  border-color: transparent transparent var(--bc) transparent;
  border-width: calc(var(--w) * 1px) calc(var(--w) / 2 * 1px);
  position: absolute;
  top: -75%;
}
.btntextw {
  position: relative;
}
.btntext {
  display: flex;
  justify-content: center;
  cursor: pointer;
}

.btntext .btn {
  position: absolute;
  z-index: 1;
}

.btntext .text {
  position: absolute;
  z-index: 3;
  transform: translateY(50%);
}

.btntext .img {
  z-index: 2;
  position: absolute;
  display: flex;
  transform: translateY(50%);
}

.lee-luck-draw-layout {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.lee-luck-draw-prizes {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.lee-luck-draw canvas {
  position: absolute;
}

.bgcolor {
  width: var(--w);
  height: var(--h);
  background: var(--bg);
  border-radius: 100%;
  padding: var(--pd);
  position: absolute;
}

.bgimg {
  width: var(--w);
  height: var(--h);
  border-radius: 100%;
  position: absolute;
}

.bgimg .bcimg {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}
</style>
